import { createAction, props } from "@ngrx/store";
import { VigilantApiDtosOrgsGetResponse } from "./orgs.model";

const prefix = "Orgs.";

/**
 * Action to set Channels in the store.
 *
 * @property {VigilantApiDtosOrgsGetResponse[]} orgs - An array of Channel objects to be set.
 */
export const SetOrgs = createAction(`${prefix}SetOrgs`, props<{ orgs: VigilantApiDtosOrgsGetResponse[] }>());

/**
 * Action to reset the Channels state.
 */
export const ResetOrgs = createAction(`${prefix}ResetOrgs`);

/**
 * Action to add a single Channel to the store.
 *
 * @property {VigilantApiDtosOrgsGetResponse} org - The Channel object to add.
 */
export const AddOrg = createAction(`${prefix}AddOrg`, props<{ org: VigilantApiDtosOrgsGetResponse }>());

/**
 * Action to add multiple Channels to the store.
 *
 * @property {VigilantApiDtosOrgsGetResponse[]} orgs - An array of Channel objects to add.
 */
export const AddOrgs = createAction(`${prefix}AddOrgs`, props<{ orgs: VigilantApiDtosOrgsGetResponse[] }>());

/**
 * Action to update a single Channel in the store.
 *
 * @property {VigilantApiDtosOrgsGetResponse} org - The Channel object with updated data.
 */
export const UpdateOrg = createAction(`${prefix}UpdateOrg`, props<{ org: VigilantApiDtosOrgsGetResponse }>());

/**
 * Action to update multiple Channels in the store.
 *
 * @property {VigilantApiDtosOrgsGetResponse[]} orgs - An array of Channel objects with updated data.
 */
export const UpdateOrgs = createAction(`${prefix}UpdateOrgs`, props<{ orgs: VigilantApiDtosOrgsGetResponse[] }>());

/**
 * Action to delete a single Channel from the store.
 *
 * @property {number} id - The unique identifier of the Channel to be deleted.
 */
export const DeleteOrg = createAction(`${prefix}DeleteOrg`, props<{ id: number }>());

/**
 * Action to delete multiple Channels from the store.
 *
 * @property {number[]} ids - An array of unique identifiers for the Channels to be deleted.
 */
export const DeleteOrgs = createAction(`${prefix}DeleteOrgs`, props<{ ids: number[] }>());
